import React from 'react';


const PostPlaceholder = () => {
 return (
   <div style={{ padding: '2rem' }}>
     <h2>This is a placeholder for the post you clicked on!</h2>
   </div>
 );
};


export default PostPlaceholder;
